import React from 'react';
import { Chip } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

/*
  StatusChip: soft-tinted status badge with consistent, accessible colors.
  Props:
   - status: 'success' | 'info' | 'warning' | 'error' | 'primary' | 'neutral'
   - label, size, sx and any other Chip props pass through.
*/

export default function StatusChip({ status = 'neutral', label, size = 'small', sx, ...rest }) {
  const theme = useTheme();
  const styles = {
    success: { bgcolor: alpha(theme.palette.success.main, 0.12), color: theme.palette.success.dark },
    info: { bgcolor: alpha('#2196f3', 0.12), color: '#1565c0' },
    warning: { bgcolor: alpha(theme.palette.warning.main, 0.15), color: '#9a5700' },
    error: { bgcolor: alpha(theme.palette.error.main, 0.12), color: theme.palette.error.dark },
    primary: { bgcolor: alpha(theme.palette.primary.main, 0.1), color: theme.palette.primary.dark },
    neutral: { bgcolor: theme.palette.grey[100], color: theme.palette.grey[700] },
  };
  const { bgcolor, color } = styles[status] || styles.neutral;

  return (
    <Chip
      label={label}
      size={size}
      sx={{ bgcolor, color, fontWeight: 600, ...sx }}
      {...rest}
    />
  );
}
